// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1p6mo","text":"SelectPayment_text__1N5kI","title":"SelectPayment_title__u5ZaI","btn":"SelectPayment_btn__2hFO-"};